import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { SubjectCard } from "../../components/Subject-section/SubjectCard";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getChemLesson,
  getMyStudyPacks,
  getStudyPacks,
} from "../../apiCalls/userApiCalls";
import CommonHeader from "../../components/common/commonHeader/CommonHeader";
import Header from "../../components/HomeComponents/Header/Header";
import { Loader } from "../../components/loaderComponent/Loding";
import { StudyPackCard } from "../../components/StudyPackComponents/StudyPackCard";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { MyStudyPackCard } from "../../components/StudyPackComponents/MyStudyPackCard";
import { ToastContainer } from "react-toastify";
import { clearStudyPack } from "../../redux/reduxSlice/studyPackRedux";
import StudyPackHeader from "../../components/common/studyPackHeader/StudyPackHeader";

const PaymentStatusEnum = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const StudyPackPage = () => {
  const dispatch = useDispatch();

  const studyPackUser = JSON.parse(sessionStorage.getItem("studyPackUser"));
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    let data = {};
    if (value === 0) {
      data = {
        subject: "chemistry",
      };
      dispatch(clearStudyPack());
      getStudyPacks(data, dispatch);
    } else if (value === 1) {
      data = {
        subject: "physics",
      };
      dispatch(clearStudyPack());
      getStudyPacks(data, dispatch);
    } else if (value === 2) {
      dispatch(clearStudyPack());
      if (studyPackUser?._id) {
        data = {
          subject: "chemistry",
          studypackUserId: studyPackUser._id,
        };

        getMyStudyPacks(data, dispatch);
      }
    } else if (value === 3 && studyPackUser?._id) {
      dispatch(clearStudyPack());
      dispatch(clearStudyPack());
      if (studyPackUser?._id) {
        data = {
          subject: "physics",
          studypackUserId: studyPackUser._id,
        };

        getMyStudyPacks(data, dispatch);
      }
    }
  }, [value]);

  const isFetching = useSelector((state) => state.studyPack.isFetching);
  const studyPacks = useSelector((state) => state.studyPack.studyPacks);

  const handleChange = (event, newValue) => {
    console.log(newValue);
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <ToastContainer />
     
    
      <StudyPackHeader />
      <Box sx={{ width: "100%", height: "80px" }}></Box>
      {isFetching ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundRepeat: "repeat",
            backgroundImage: `url(${"https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fbackground.png?alt=media&token=a9467179-4448-456a-9892-de49d2eef4b7"})`,
            objectPosition: "left",
            backgroundPosition: "center",
          }}
        >
          <Typography
            variant="h3"
            sx={{ fontWeight: 700, fontFamily: "Anton, sans-serif" }}
          >
            Study Pack
          </Typography>

          <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            sx={{
              marginTop: "10px",
              borderRadius: "100px",
              color: "white",
              backgroundColor: "#C4C4C4",
              maxWidth: "90%",
            }}
          >
            <Tab
              label="Chemisty Packs"
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "red",
                  color: "white",
                  textDecoration: "none", // Customize the background color for the selected tab
                },
              }}
            />
            <Tab
              label="Physics Packs"
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "blue",
                  color: "white",
                  textDecoration: "none", // Customize the background color for the selected tab
                },
              }}
            />
            <Tab
              label="My Chemistry Packs"
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "yellow",
                  color: "white",
                  textDecoration: "none", // Customize the background color for the selected tab
                },
              }}
            />
            <Tab
              label="My Physics Packs"
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "green",
                  color: "white",
                  textDecoration: "none", // Customize the background color for the selected tab
                },
              }}
            />
          </Tabs>

          {studyPacks.length > 0 ? (
            <Grid
              sx={{
                marginTop: "10px",
              }}
              container
              pl={2}
              pr={2}
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              {studyPacks.length > 0 &&
                studyPacks.map((subject, index) => {
                  return (
                    <Grid key={index} item xs={12} sm={6} md={3}>
                      {value === 2 || value === 3 ? (
                        <MyStudyPackCard subject={subject} />
                      ) : (
                        <StudyPackCard subject={subject} />
                      )}
                    </Grid>
                  );
                })}
            </Grid>
          ) : (
            <Grid
              container
              item
              xs={12}
              sm={12}
              md={12}
              justifyContent={"center"}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: 400, marginTop: "100px" }}
              >
                No Lessons
              </Typography>
            </Grid>
          )}
        </Box>
      )}
    </React.Fragment>
  );
};
